import { render, staticRenderFns } from "./SchoolPicker.vue?vue&type=template&id=2dd74da1&"
import script from "./SchoolPicker.vue?vue&type=script&lang=js&"
export * from "./SchoolPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports